import { render, staticRenderFns } from "./PersonEditor.vue?vue&type=template&id=c8b9c2dc&scoped=true&"
import script from "./PersonEditor.vue?vue&type=script&lang=js&"
export * from "./PersonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b9c2dc",
  null
  
)

export default component.exports